exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".duck{display:block;width:120px;margin:1.5rem auto}", "", {"version":3,"sources":["/./src/routes/Home/components/src/routes/Home/components/HomeView.scss"],"names":[],"mappings":"AAAA,MACE,cAAe,YACF,kBACO,CACrB","file":"HomeView.scss","sourcesContent":[".duck {\n  display: block;\n  width: 120px;\n  margin: 1.5rem auto;\n}\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap&-minimize!./~/postcss-loader!./~/sass-loader?sourceMap!./src/routes/Home/components/HomeView.scss
// module id = 383
// module chunks = 0